module.exports = __webpack_public_path__ + "static/section-2-7a297f7b9c9a6e504bba025c15ca4372.jpg";